export default __webpack_public_path__ + "static/media/login.6ba15156.jpg";